import LazyImg from '../common/LazyImg';

/**
 * PostImg is essentially an alias for LazyImg
 */
const PostImg = ({ ...rest }) => <LazyImg {...rest} />;

export default PostImg;
